import {useTranslation} from "react-i18next";
import {useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import Deposits from "./deposits";
import TransactionsBets from "./bets";
import TransactionsReloads from "./reloads";
import TransactionTips from "./tips";
import Rakebacks from "./rakebacks";
import TransactionsWithdrawal from "./withdrawals";
import TransactionBonuses from "./bonuses";
import {useSelector} from "react-redux";
import TransactionDiscounts from "./discounts";
import SvgIcon from "../../components/svg-icon";
import TransactionCorrections from "./corrections";

const tt = ['deposits', 'withdrawals','corrections', 'bonuses', 'bets', 'rakebacks', 'reloads', 'tips']
// const tt = ['deposits', 'withdrawals','corrections', 'bonuses',  'rakebacks', 'reloads', 'tips']
const Transactions = () => {
    const {configuration} = useSelector(state => state.globalReducer)
    const [activeTab, setActiveTab] = useState("deposits")
    const {t} = useTranslation()
    // discount_able
    const [searchParams, setSearchParams] = useSearchParams()
    const [tabs, setTabs] = useState(tt)

    useEffect(() => {
        const tab = searchParams.get('tab')
        if (tab && tabs.includes(tab))
            setActiveTab(tab)
    }, [searchParams])

    const handleTab = (tab) => setSearchParams({tab: tab})

    useEffect(() => {
        setTabs(prevState => configuration?.discount_able ? [...prevState?.filter(i => i !== 'discount'), 'discounts'] : tt)
    }, [configuration?.discount_able])

    const getDynamicContent = () => {
        switch (activeTab) {
            case 'deposits':
                return <Deposits/>

            case 'withdrawals':
                return <TransactionsWithdrawal/>

            case 'corrections':
                return <TransactionCorrections/>

            case 'bets':
                return <TransactionsBets/>

            case 'reloads':
                return <TransactionsReloads/>

            case 'tips':
                return <TransactionTips/>

            case 'bonuses':
                return <TransactionBonuses/>

            case 'rakebacks':
                return <Rakebacks/>


            case 'discounts':
                return <TransactionDiscounts/>

            default:
                return false;
        }
    }

    return (
        <div className="section section--first">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h1 className="section__title section__title--head">{t('transactions.title')}</h1>
                    </div>

                    <div className="col-12">
                        <div className="content">
                            <div className="dropdown content__dropdown">
                                <button
                                    className="dropdown-toggle content__dropdown-toggle"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    {t(`transactions.tabs.${activeTab}`)}

                                    <SvgIcon id={'right-down'}/>
                                </button>
                                <ul
                                    className="dropdown-menu content__dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                >
                                    {
                                        tabs?.map(tab => (
                                            <li key={tab}>
                                                <button
                                                    onClick={e => handleTab(tab)}
                                                    className="dropdown-item content__dropdown-item"
                                                    type="button"
                                                >
                                                    <SvgIcon id={'arrow-dash'}/>
                                                    {t(`transactions.tabs.${tab}`)}
                                                </button>
                                            </li>
                                        ))
                                    }


                                </ul>
                            </div>
                            <div className="content__menu">
                                <ul
                                    className="nav nav-tabs content__nav"
                                    id="content__nav"
                                    role="tablist"
                                >
                                    {
                                        tabs?.map(tab => (
                                            <li key={tab} className="nav-item" role="presentation">
                                                <button
                                                    onClick={e => handleTab(tab)}
                                                    className={activeTab === tab ? 'active' : ''}>
                                                    <SvgIcon id={'arrow-dash'}/>
                                                    {t(`transactions.tabs.${tab}`)}
                                                </button>
                                            </li>
                                        ))
                                    }

                                </ul>
                            </div>

                            <div className="content__main">
                                <div className="tab-content">
                                    {
                                        getDynamicContent()
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )


}
export default Transactions
